export default {
    GET_AUDIT_LOGS_BY_SUPERUSER_REQUEST: 'GET_AUDIT_LOGS_BY_SUPERUSER_REQUEST',
    GET_AUDIT_LOGS_BY_SUPERUSER_SUCCESS: 'GET_AUDIT_LOGS_BY_SUPERUSER_SUCCESS',
    GET_AUDIT_LOGS_BY_SUPERUSER_FAIL: 'GET_AUDIT_LOGS_BY_SUPERUSER_FAIL',

    GET_AUDIT_LOGS_BY_ORG_ADMIN_REQUEST: 'GET_AUDIT_LOGS_BY_ORG_ADMIN_REQUEST',
    GET_AUDIT_LOGS_BY_ORG_ADMIN_SUCCESS: 'GET_AUDIT_LOGS_BY_ORG_ADMIN_SUCCESS',
    GET_AUDIT_LOGS_BY_ORG_ADMIN_FAIL: 'GET_AUDIT_LOGS_BY_ORG_ADMIN_FAIL',
}
  